import { Directive, ElementRef, Input } from '@angular/core';
import type { SwiperOptions } from 'swiper/types';

@Directive({
	selector: '[swiperElement]',
	standalone: false,
})
export class SwiperDirective {
	@Input() config?: SwiperOptions;
	private readonly swiperElement: HTMLElement;

	constructor(private element: ElementRef) {
		this.swiperElement = element.nativeElement;
	}

	ngAfterViewInit(): void {
		Object.assign(this.element.nativeElement.swiper, this.config);

		console.dir(this.element.nativeElement);
	}
}
